export default __webpack_public_path__ + "static/media/fleet-efficiency.1c36cac9.svg";